// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"80c26094","239":"e1840306","245":"4a4ef829","347":"6d638076","372":"0d59ca25","396":"9bfac39b","705":"ee0d82e2","885":"e93450b1","929":"484697a8","991":"28c6d2dd"}[chunkId] + ".chunk.js";
};